import * as e from "react";
const o = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", width: "1em", height: "1em", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M26 21h-4.5v2h8v-8h-2v4.6l-10.3-9.3-.7-.7-.7.7-5.3 5.3-7.8-7.3-1.4 1.4 8.5 8 .7.7.7-.7 5.3-5.3L26 21Z", clipRule: "evenodd" }));
export {
  o as ReactComponent
};
